import React from 'react';
import { applyMiddleware, compose, createStore } from 'redux';
import ReactDOM from 'react-dom';
import Page from './components/Page';
import { Provider } from 'react-redux';
import step from './reducers';
//import { refreshStudies, fetchSites } from './actions/sites';
import thunk from 'redux-thunk';
import * as API from './api';
import $ from 'jquery';
import { error } from 'plugins/toastr';

import { getIsDirty } from './reducers/dirty';
import { withCurrentReferer } from 'plugins/contextual-back';
import ReactDOMServer from 'react-dom/server';
import { bindModal } from '../../common/modals';

function dispatchErrors(store, error) {
  const errors = Object.keys(error)
    .map(key => {
      return key.substring(4);
    })
    .filter(e => e !== null);

  store.dispatch({
    type: 'errors',
    payload: errors,
  });
}

function handleError(err, store) {
  console.log('Error attempting to save case', err);
  if (err.res.status === 400) {
    // Handling errors properly
    err.res.json().then(json => dispatchErrors(store, json));
  } else {
    error('Une erreur est survenue pendant la sauvegarde du dossier');
  }
}

const displayConfirmModal = (id, form, callback) => {
  const title = 'Confirmation';
  const confirmationContent =
    "Êtes-vous sûr de valider le renouvellement du contrat? Le contrat ne sera plus modifiable jusqu'au prochain renouvellement.";

  const renderActions = (
    <div className="actions">
      <div className="ui approve primary button">Valider</div>
      <div className="ui cancel button">Annuler</div>
    </div>
  );

  const modal = ReactDOMServer.renderToStaticMarkup(
    <ConfirmModal
      title={title}
      content={confirmationContent}
      actions={renderActions}
    />
  );
  displayModal(modal, callback, id, form);
};

export function bind() {
  const createLogger = require('redux-logger');
  const logger = createLogger({
    collapsed: true,
  });

  const middleware = [thunk, logger];
  const enhancers = [];

  const root = document.getElementById('renew-contract');
  const id = root.getAttribute('data-id');
  const contractId = root.getAttribute('data-contract-id');
  const customerId = root.getAttribute('data-customer');
  const isExisting = root.getAttribute('data-is-existing');
  const startContractDate = root.getAttribute('data-start-contract-date');

  const store = createStore(
    step,
    compose(applyMiddleware(...middleware), ...enhancers)
  );

  const dirtyHandler = () => {
    if (getIsDirty(store.getState())) {
      $('#renew-contract form').addClass('dirty');
    }
  };

  store.subscribe(dirtyHandler);

  ReactDOM.render(
    <Provider store={store}>
      <Page
        id={parseInt(id, 10)}
        contractId={parseInt(contractId, 10)}
        isExisting={isExisting === 'true'}
        customerId={parseInt(customerId, 10)}
        startContractDate={startContractDate}
      />
    </Provider>,
    root
  );

  const cleanDirty = () => $('#renew-contract form').removeClass('dirty');

  const saveButton = document.getElementById('bt-save');
  if (saveButton) {
    const id = saveButton.getAttribute('data-id');
    saveButton.onclick = () => {
      cleanDirty();
      API.update(id, store.getState().form).then(
        res => window.location.replace(withCurrentReferer(res.url)),
        err => handleError(err, store)
      );
    };
  }

  const validateButton = document.getElementById('bt-validate');
  if (validateButton) {
    const id = validateButton.getAttribute('data-id');
    const callback = (id, form) => {
      cleanDirty();
      API.validate(id, form).then(
        res => window.location.replace(withCurrentReferer(res.url)),
        err => handleError(err, store)
      );
    };
    validateButton.onclick = () => {
      displayConfirmModal(id, store.getState().form, callback);
    };
  }

  bindModal();
}

function displayModal(modal, callback, id, form) {
  // Appending content to body
  $(document.body).append(modal);

  // Handling approve button
  const $modal = $('#confirm-action-modal');

  $modal
    .modal({
      onApprove: element => {
        // Execute action and hiding it on executed
        callback(id, form);

        return true;
      },
    })
    .modal('show');
}

const ConfirmModal = ({ title, content, haveWarningIcon = true, actions }) => {
  const renderActions = actions ? (
    actions
  ) : (
    <div className="actions">
      <div className="ui primary approve button">Confirmer</div>
      <div className="ui cancel button">Annuler</div>
    </div>
  );
  return (
    <div id="confirm-action-modal" className="ui small modal">
      <div className="header">
        {haveWarningIcon && <i className="icon warning circle" />}
        {title}
      </div>
      <div className="content" style={{ marginBottom: '20px' }}>
        <p dangerouslySetInnerHTML={{ __html: content }} />
      </div>
      {renderActions}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-contract/renew/index.js